







































































































































































































































































import { Vue } from 'vue-property-decorator';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import NOC from '@/class/common/const';

import ConfrimDialog from '@/parts/app/ConfrimDialog.vue';
import QuitLoginModal from '@/parts/account/QuitLoginModal.vue';
// import SideBar from '@/parts/app/SideBar.vue';
import TopBar from '@/parts/app/TopBar2.vue';
import apps from '@/parts/app/disp/index';

import * as models from '@/class/models/views/app';
import * as modelsNews from '@/class/models/views/news';
import * as modelsAlert from '@/class/models/views/alert';
import API from '@/api/common';
import isMobile from 'ismobilejs';
import Footer from '@/components/Footer.vue';
import { isEnabledEnv } from './class/common/util/env-util';
import { isRoleAdmin, isRoleAdminOrManager, ROLE_FLAG_ADMIN_OR_MANAGER } from './class/common/util/role_util';
import { DEFAULT_PATH_FOR_ADMIN_OR_MANAGER, DEFAULT_PATH_FOR_GENERAL, ViewPagePermission, checkViewPagePermissionMeta, findRouterConfigMetaData, getDefaultPathForRole } from './router';
import { isRoleExternalAdminOrManager, isRoleWithoutInternalAdmin } from './util/role-util-frontend';

interface Data {
  appData: models.CApp;
  routerClick: boolean;
  disp: string;
  errormodal: boolean;
  forgetmodal: boolean;
  confirmmodal: boolean;
  modal: boolean;
  modalMessage: string;
  dispClick: boolean;
  ownerFlag: boolean;
  error: any;
  nowPath: string;
  appClass: string;
  invitationData: { mail: string; code: string };
  newsList: [];
  alertCount: number;
  ModalValue: any;
  quitLoginModal: boolean;
  quitLoginDisplay: string;
  notLoggedInScreens: string[];
  logoutModal: boolean;
  isProcessing: boolean;
  isLoadingRouterView: boolean;
  loadingCountForApp: number;
}

interface Methods {
  startLoadingApp: () => void;
  endLoadingApp: () => void;
  changeMode: (mode: string) => void;
  forgetModal: (mode: string) => void;
  errorModal: (message: string) => void;
  showModal: (message: string) => void;
  onClickMoveWELCOME: () => void;
  confirmDialog: (message: string, cancelVisible: boolean) => Promise<any>;
  check: () => Promise<void>;
  checkAuthForLoggedIn: () => Promise<void>;
  checkForLoggedOut: () => void;
  calcTransitionPath: (appData: models.CApp, path: string) => CalcTransitionPathResult;
  signup: (data: any) => Promise<void>;
  login: (value: any) => Promise<void>;
  openLogoutModal: () => void;
  closeLogoutModal: () => void;
  closeQuitModal: () => void;
  logout: () => Promise<void>;
  loading: (value: boolean) => void;
  confirm: (editData: models.INewAccount) => Promise<void>;
  invitation: (value: any) => Promise<void>;
  pushPath: (path: string) => void;
  forget: (mail: string) => Promise<void>;
  changePass: (value: any) => Promise<void>;
  getDocument: () => Promise<void>;
  getNewsList: () => Promise<void>;
  checkNews: (clickedNews: any) => void;
  checkAlert: (count: number) => void;
  addGtm: () => void;
  deleteGtm: () => void;
  changeContract: () => Promise<void>;
  parentMethod: (gaget: any) => void;
  isAccountOnlyContract: (contract: string) => boolean;
}

interface Computed {
  APP_MODE: any;
  isPhone: boolean;
  loggedIn: boolean;
  IS_LOADING: boolean;
}

/**
 * パスの種類。
 */
export const TransitionPahtType = {
  NO_CHANGE: 0, // 変更なし
  LOGOUT: 1,    // ログアウト
  TRANSIT: 2,   // 遷移する。
} as const;
// 型定義。入力値制限。
export type TransitionPahtType = typeof TransitionPahtType[keyof typeof TransitionPahtType];

/**
 * calcTransitionPaht()の戻り値。
 */
interface CalcTransitionPathResult {
  path_type: TransitionPahtType;
  path: string;
}

/**
 * CalcTransitionPathResult作成ユーティリティ。TransitionPahtType.TRANSIT版。
 */
function makeCalcTransitionPathResultTransit(path: string): CalcTransitionPathResult {
  return {
    path_type: TransitionPahtType.TRANSIT,
    path,
  };
}

export default Vue.extend({
  name: 'app',
  metaInfo: {
    title: 'RemoLabo｜リモートワークツールを簡単に導入・解決！！',
    meta: [
      { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' },
      {
        name: 'viewport',
        content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0',
      },
      { property: 'og:title', content: 'RemoLabo｜リモートワーク問題解決' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://remolabo.net/' },
      { property: 'og:image', content: 'https://remolabo.net/images/ogp.jpg' },
      {
        property: 'og:description',
        content:
          'リモートワークを管理しない。リモラボはリモートワーカーの勤務時間を自動的にグラフ化します。',
      },
    ],
  },
  components: { TopBar, QuitLoginModal, ...apps, Footer },
  data() {
    return {
      appData: new models.CApp(),
      routerClick: false,
      disp: '',
      errormodal: false,
      forgetmodal: false,
      // signupmodal: false,
      confirmmodal: false,
      modal: false,
      modalMessage: '',
      dispClick: false,
      ownerFlag: false,
      error: {},
      nowPath: '',
      appClass: '',
      invitationData: { mail: '', code: '' },
      newsList: [],
      alertCount: 0,
      ModalValue: {},
      quitLoginModal: false,
      quitLoginDisplay: NOC.CONTRACT.CONFIRM,
      // 未ログイン画面
      notLoggedInScreens: [
        NOC.APP.MODE.SIGNUP,
        NOC.APP.MODE.CONFIRM,
        // NOC.APP.MODE.,
      ],
      logoutModal: false,
      isProcessing: false,
      isLoadingRouterView: false, // <router-view>(各画面vue)がロード中か？
      loadingCountForApp: 0,  // App.vueがロード中か？（画面切り替え中など）。マルチスレッドから呼ばれるためカウント方式にする。
      isSessionChanged: false,
    };
  },
  computed: {
    APP_MODE() {
      return NOC.APP.MODE;
    },
    isPhone() {
      return isMobile().phone;
    },
    // TODO: 未ログインの判定を見直す必要有
    loggedIn() {
      return (
        !this.notLoggedInScreens.includes(this.disp) && this.appData.name !== ''
      );
    },
    IS_LOADING() {
      return this.isLoadingRouterView || this.loadingCountForApp > 0;
    },
  },
  created() {
    // VueRouterナビゲーションガード登録
    this.$router.beforeEach((to: any, from: any, next: any) => {
      // 2どよばれる

      // console.log(`beforeEach to.path=${to.path} from.path=${from.path}`);

      // 未認証
      if (this.disp !== NOC.APP.MODE.AUTH) {
        return;
      }

      // 遷移先決定
      const ctpRes = this.calcTransitionPath(this.appData, to.path);
      // console.log(`beforeEach ctpRes=${JSON.stringify(ctpRes)}`);
      switch ( ctpRes.path_type ) {
      case TransitionPahtType.LOGOUT: // ログアウト要求
        this.logout();
        return;
      case TransitionPahtType.TRANSIT: // 元パスとは別のパスへの遷移要求
        next({ path: ctpRes.path });
        return;
      case TransitionPahtType.NO_CHANGE:  // 元パスから変更なし。
        // ページ表示
        next();
        break;
      default:
        console.error(`想定外のpath_type(${ctpRes.path_type})です。`);
        return;
      }
    }); // end this.$router.beforeEach()
  },
  async mounted() {
    // ローディング画面表示。
    this.startLoadingApp();

    // 別タブなどのセッションの変化を監視
    window.addEventListener('storage', () => {
      if (!this.$data.isSessionChanged) {
        this.$data.isSessionChanged = true;
        window.addEventListener('focus', () => {
          this.check();
          this.$data.isSessionChanged = false;
        }, {once: true});
      }
    });

    if (location.pathname.indexOf('/service') > -1) {
      this.disp = 'service';
    } else {
      const mail: any = this.$route.query.mail;
      const code: any = this.$route.query.code;
      const f: any = this.$route.query.f;
      if (
        this.$route.query.mail &&
        this.$route.query.code &&
        this.$route.query.f
      ) {
        // 画面遷移
        this.disp = NOC.APP.MODE.VERIFICATION;
        // 認証
        if (this.$route.query.f !== '3') {
          const api = new API();
          const req = {} as models.VAuth;
          const res = await api.post<any, models.VDisp>(
            'auth/verification',
            this.$route.query,
          );
          if (res.result) {
            this.invitationData.mail = mail;
            this.invitationData.code = code;
            this.disp = res.data.disp;
            // this.$router.push('/', () => {});
          } else {
            this.showModal(
              '登録に失敗しました。メールアドレスを再確認してください。',
            );
            this.disp = NOC.APP.MODE.WELCOME;
            // this.$router.push('/', () => {});
          }
        } else {
          const api = new API();
          const req = {} as models.VAuth;
          const res = await api.post<any, models.VDisp>(
            'auth/changeVerification',
            this.$route.query,
          );
          if (res.result) {
            this.invitationData.mail = mail;
            this.invitationData.code = code;
            this.disp = res.data.disp;
            // this.$router.push('/', () => {});
          } else {
            this.showModal(
              '登録に失敗しました。メールアドレスを再確認してください。',
            );
          }
        }
      } else {
        await this.check();
      }
      this.nowPath = this.$route.path;
    }

    // ローディング画面非表示
    this.endLoadingApp();
  },
  methods: {
    // ローディングアイコン表示
    startLoadingApp() {
      this.loadingCountForApp++;
      // console.log("startLoadingApp loadingCountForApp=" + this.loadingCountForApp);
    },
    // ローディングアイコン非表示
    endLoadingApp() {
      if ( this.loadingCountForApp > 0 ) {
        this.loadingCountForApp--;
      }
      // console.log("endLoadingApp loadingCountForApp=" + this.loadingCountForApp);
    },
    // 表示モードの変更と画面遷移
    changeMode(mode: string) {
      if (process.env.VUE_APP_MAINTENANCE === 'true') {
        let nextMode = mode;
        if (
          !(
            mode === NOC.APP.MODE.WELCOME ||
            mode === NOC.APP.MODE.MAINTENANCE ||
            mode === NOC.APP.MODE.ERROR
          )
        ) {
          nextMode = NOC.APP.MODE.MAINTENANCE;
          // console.log('change')
        }
        this.disp = nextMode;
        this.$router.push(`/${nextMode}`, () => {});
      } else {
        this.disp = mode;
        this.$router.push(`/${mode}`, () => {});
      }
    },
    forgetModal(mode: string) {
      this.disp = mode;
      this.$router.push(`/${mode}`, () => {});
      this.forgetmodal = false;
    },
    // signupModal(mode: string) {
    //   this.disp = mode;
    //   this.$router.push(`/${mode}`, () => {});
    //   this.signupmodal = false;
    // },
    errorModal(message: string) {
      this.errormodal = true;
      this.modalMessage = message;
    },
    showModal(message: string) {
      this.modal = true;
      this.modalMessage = message;
    },
    onClickMoveWELCOME() {
      this.disp = NOC.APP.MODE.WELCOME;
      this.forgetmodal = false;
      // this.signupmodal = false;
      // this.$emit('change', this.disp);
    },
    async confirmDialog(
      message: string,
      cancelVisible: boolean = true,
    ): Promise<any> {
      return await new Promise(resolve => {
        const VM = Vue.extend(ConfrimDialog);
        return new VM({
          parent: this,
          propsData: {
            message,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
            cancelVisible,
          },
        });
      }).catch(err => {
        throw err;
      });
    },
    // 認証チェックとページ遷移。
    async check() {
      // メンテナンス環境変数がtrueのときはメンテナンス画面を表示
      if ( isEnabledEnv( process.env.VUE_APP_MAINTENANCE ) ) {
        this.changeMode(NOC.APP.MODE.MAINTENANCE);
        return;
      }

      // ログイン中か？
      if (localStorage.getItem(NOC.N16.DIR)) {
        // ログイン中
        await this.checkAuthForLoggedIn();  // 認証チェックとページ遷移
      } else {
        // ログアウト中
        this.checkForLoggedOut();
      }
    },
    // 認証チェック(ログイン中)
    async checkAuthForLoggedIn() {
      // 通信して認証確認
      const api = new API();
      const res = await api.get<models.VApp>('auth/check');
      if (!res.result) {
        // 認証エラー
        // ローカルストレージに保存してある認証トークンを削除。
        localStorage.removeItem(NOC.N16.DIR);
        // エラーページへ
        this.changeMode(NOC.APP.MODE.ERROR);
        return;
      }

      // console.log(`checkAuthForLoggedIn res.data=${JSON.stringify(res.data)}`);
      // データエラーの場合は、ログイン画面へ。
      const GOTO_ERROR_DISP_MODE = NOC.APP.MODE.LOGIN;  // エラー時の遷移先画面
      //// res.dataがない場合
      if ( !res.data ) {
        console.error('res.data is missing.');
        this.disp = GOTO_ERROR_DISP_MODE;
        return ;
      }
      //// res.data.appDataがない場合
      if ( !res.data.appData ) {
        console.error('res.data.appData is missing.');
        this.disp = GOTO_ERROR_DISP_MODE;
        return ;
      }

      // appData保持
      this.appData = res.data.appData;

      // 会社名がなければ「会社情報入力」画面へ。（新規登録時）
      if (this.appData.name === '') { // appData.name は DBのaccountテーブルのcompany_nameが入る。
        this.disp = NOC.APP.MODE.CONFIRM;
        return ;
      }

      // 環境変数VUE_APP_PREがtrueなら、「サービス開始前」画面へ（「サービス開始はx年x月x日を予定しております。」画面）
      if ( isEnabledEnv( process.env.VUE_APP_PRE) ) {
        this.disp = NOC.APP.MODE.COMING;
        return;
      }

      // オーナーフラグ設定
      // todo takezawa removeme 一般ユーザーのログイン対応に伴いownerFlagは廃止予定。appData.roleをrole_util.tsで直接判定する方法に移行。
      this.ownerFlag = Number(this.appData.role) === NOC.SETTING.ROLE.VALUE.ADMIN;

      // 契約状態が「拒否」の場合ログアウト
      if (this.appData.contractStatus === NOC.CONTRACT.DENY) {
        this.logout();
        return;
      }

      // ニュースリスト更新
      this.getNewsList();

      // 表示モードを認証済とする。
      this.disp = NOC.APP.MODE.AUTH;

      // 遷移先決定
      const ctpRes = this.calcTransitionPath(this.appData, this.$route.path);
      switch ( ctpRes.path_type ) {
      case TransitionPahtType.LOGOUT: // ログアウト要求
        this.logout();
        break;
      case TransitionPahtType.TRANSIT: // 元パスとは別のパスへの遷移要求
        await this.$router.push(ctpRes.path, () => {});
        break;
      case TransitionPahtType.NO_CHANGE:  // 元パスから変更なし。
        this.nowPath = this.$route.path;
        break;
      default:
        console.error(`想定外のpath_type(${ctpRes.path_type})です。`);
        break;
      }
    },
    // 認証チェック(未ログイン中)後の遷移
    checkForLoggedOut() {
      const pathWithoutRoot = location.pathname.replace('/', '');
      // console.log(`checkForLoggedOut pathWithoutRoot=${pathWithoutRoot}`);

      // ルート設定メタデータ取得
      // @note this.$route.path は、Vue RouterのURLの解析が終わらず一時的に中身が「/」になってしまうことがあるため、location.pathname を使用する。
      const meta = findRouterConfigMetaData(location.pathname);

      // ページが閲覧可能か判定
      const permission = checkViewPagePermissionMeta( meta, NOC.SETTING.ROLE.VALUE.NONE /* 未ログイン指定 */ );
      switch ( permission ) {
      case ViewPagePermission.ALLOW:     // 許可
        this.disp = pathWithoutRoot;
        break;
      case ViewPagePermission.DENY:      // 拒否
        // Welcome画面へ
        this.disp = NOC.APP.MODE.WELCOME;
        break;
      default:
          console.error(`未対応のpermission(${permission})です。`);
          return ;
      }

      // console.log(`checkForLoggedOut permission=${permission} disp=${this.disp}`);
      this.changeMode(this.disp);
      // 未ログイン時gtmタグ追加
      this.addGtm();
    },
    // 最終的な遷移先を決める
    calcTransitionPath(appData: models.CApp, path: string): CalcTransitionPathResult {
      // console.log(`calcTransitionPath path=${path} route.path=${this.$route.path} location.pathname=${location.pathname}`);

      // デフォルト戻り値。パスの変更なし。
      let result: CalcTransitionPathResult  = {
        path_type: TransitionPahtType.NO_CHANGE,
        path,
      };

      // ルートパスの場合はロールに応じてデフォルト画面に遷移
      if ( path === '/') {
        if ( isRoleAdminOrManager(appData.role) ) {
          result = makeCalcTransitionPathResultTransit( DEFAULT_PATH_FOR_ADMIN_OR_MANAGER );
        } else {
          result = makeCalcTransitionPathResultTransit( DEFAULT_PATH_FOR_GENERAL );
        }
        return result;
      }

      const pathExternalAdminOrManager: string[] =
        [
          '/dashboard',
          '/labor/management/monthly',
          '/labor/management/daily',
        ];
      const pathWithoutInternalAdmin: string[] =
        [
          '/labor/regist/monthly',
          '/labor/regist/daily',
        ];

      // 環境変数で閲覧権限が変化する画面の場合
      if
      (
        (pathExternalAdminOrManager.some(viewPath => viewPath === path) &&
          false == isRoleExternalAdminOrManager(this.appData.role)) ||
        (pathWithoutInternalAdmin.some(viewPath => viewPath === path) &&
          false == isRoleWithoutInternalAdmin(this.appData.role))
      ) {
          // 閲覧権限がない場合はユーザー管理画面に遷移。
          // （一般ユーザーはユーザー管理画面も閲覧権限がないため、再帰的にデフォルト画面に遷移する。）
          result = makeCalcTransitionPathResultTransit( '/setting/users' );
          console.info(`calcTransitionPath 閲覧権限がないため遷移先変更。 元パス:'${path}' 遷移先:${JSON.stringify(result)}`);
          return result;
        }

      // ルート設定メタデータ取得
      const meta = findRouterConfigMetaData(path);

      // 不完全契約状態か？
      if ( this.isAccountOnlyContract(appData.contractStatus) ) {
        // 退会済み/遅延猶予期間/停止 の場合

        // 労務管理者の場合ログイン画面へ遷移
        if (!isRoleAdmin( appData.role ) ) {
          result.path_type = TransitionPahtType.LOGOUT;
          console.info(`calcTransitionPath 不完全契約状態かつ労務管理者のためログアウト。 元パス:'${path}' 遷移先:${JSON.stringify(result)}`);
          return result;
        }
        // -- アカウント管理者の場合 --
        // 不完全契約状態でもアクセス許可のある画面以外は、アカウント画面に遷移。
        if ( meta && meta.is_allow_account_only_contract ) {
          // 不完全でもアクセス可能な画面。
          return result;  // パス変更なしでそのままアクセス。
        } else {
          // 不完全契約状態によるアクセス不可画面なのでアカウント画面に遷移。
          result = makeCalcTransitionPathResultTransit('/license');
          console.info(`calcTransitionPath 不完全契約状態アクセス不可画面のため遷移先変更。 元パス:'${path}' 遷移先:${JSON.stringify(result)}`);
          return result;
        }
        // -- アカウント管理者の場合 end --
      } // end if ( this.isAccountOnlyContract(appData.contractStatus) )

      // -- 以降、契約中(退会済み/遅延猶予期間/停止以外）の場合 --
      // 認証済みでログイン前画面を開こうとした場合はデフォルト画面に遷移
      if ( meta && meta.is_deny_after_login ) {
          result = makeCalcTransitionPathResultTransit( getDefaultPathForRole(appData.role) );
          console.info(`calcTransitionPath ログイン後アクセス不可画面のため遷移先変更。 元パス:'${path}' 遷移先:${JSON.stringify(result)}`);
          return result;
      }

      // ログインユーザーの権限で、ページが閲覧可能か判定
      const permission = checkViewPagePermissionMeta( meta, appData.role );
      // console.log(`calcTransitionPath permission=${permission}`);
      switch ( permission ) {
      case ViewPagePermission.ALLOW:     // 許可
        // なにもせずに次のコードへ。
        break;
      case ViewPagePermission.DENY:      // 拒否
        // 404画面へ
        result = makeCalcTransitionPathResultTransit('Error_404');
        console.info(`calcTransitionPath 閲覧権限がないページのため遷移先変更。 元パス:'${path}' 遷移先:${JSON.stringify(result)}`);
        return result;
      default:
        result = makeCalcTransitionPathResultTransit('Error_404');
        console.error(`未対応のpermission(${permission})です。`);
        return result;
      }

      // デフォルト戻り値を返す。パスの変更無し。
      // console.info(`calcTransitionPath default ${JSON.stringify(result)}`);
      return result;
    },
    // サインアップ
    async signup(data: any) {
      // 通信
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/signup', data);

      if (res.result) {
        // console.log(res);
        // 通信成功時
        if (!res.data.message) {
          // this.disp = NOC.APP.MODE.THANKS;
          // this.changeMode(this.disp);
          location.href = '/thanks/regist.html';
          // this.signupmodal = true;
        } else {
          this.error = res.data.message;
        }
      } else {
        this.errorModal('登録に失敗しました。');
      }
      // this.disp = flag;
    },
    async login(value: any) {
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/login', value);

      if (res.result) {
        this.deleteGtm();
        // this.disp = NOC.APP.MODE.AUTH;
        this.appData = res.data.appData;
        if (this.appData.name === '') {
          this.disp = NOC.APP.MODE.CONFIRM;
          // this.$router.push(`/`, () => {});
        } else {
          if (process.env.VUE_APP_PRE !== '1') {
            this.disp = NOC.APP.MODE.AUTH;
            this.ownerFlag = Number(this.appData.role) === 1;
            this.nowPath = this.$route.path;
            this.quitLoginDisplay = NOC.CONTRACT.CONFIRM;
            if (this.appData.contractStatus === NOC.CONTRACT.DENY) {
              // アカウント停止
              this.quitLoginModal = true;
              this.quitLoginDisplay = NOC.CONTRACT.DENY;
              // this.logout();
            } else {
              this.getNewsList();
              if (this.isAccountOnlyContract(this.appData.contractStatus)) {
                // 退会済み/遅延猶予期間/停止
                if (this.ownerFlag) {
                  // 管理者の場合アカウント画面に遷移
                  await this.$router.push(`/license`, () => {});
                } else {
                  // 労務管理者の場合ログインさせない
                  if (this.appData.contractStatus === NOC.CONTRACT.QUIT) {
                    this.quitLoginDisplay = NOC.CONTRACT.QUIT;
                  }
                  this.quitLoginModal = true;
                  // this.logout();
                }
              } else {
                await this.$router.push(`/`, () => {});
              }
            }
          } else {
            this.disp = NOC.APP.MODE.COMING;
          }
        }
      } else {
        this.errorModal('ユーザー名またはパスワードが正しくありません。');
      }
    },
    openLogoutModal() {
      this.logoutModal = true;
    },
    closeLogoutModal() {
      this.logoutModal = false;
    },
    // 利用期間停止|利用停止モーダルを閉じてログアウトを行う処理
    closeQuitModal() {
      this.quitLoginModal = false;
      this.logout();
    },
    loading(value: boolean) {
      this.isLoadingRouterView = value;
    },
    async logout() {
      this.logoutModal = false;
      // logout
      const api = new API();
      const res = await api.get<any>('auth/logout');
      // console.log(res);
      if (!res.result) {
        console.log(res);
      }
      localStorage.removeItem(NOC.N16.DIR);
      // this.disp = NOC.APP.MODE.LOGIN;
      this.disp = NOC.APP.MODE.WELCOME;

      this.changeMode(this.disp);

      // ログアウト時gtmタグ追加
      this.addGtm();
    },
    async confirm(editData: models.INewAccount): Promise<void> {
      // メールを合流
      editData.mail = this.appData.mail;
      // api start
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<models.IAccount, any>(
        'auth/confirm',
        editData,
      );
      // result
      if (res.result) {
        // 成功時
        if (process.env.VUE_APP_PRE !== '1') {
          await this.check();
          await this.$router.push(`/`, () => {});
        } else {
          this.disp = NOC.APP.MODE.COMING;
          this.changeMode(this.disp);
        }
      } else {
        // this.$emit('info', '登録できませんでした。');
        this.errorModal('登録できませんでした。');
      }
      this.isProcessing = false;
    },
    async invitation(value: any) {
      const api = new API();
      value.mail = this.invitationData.mail;
      value.code = this.invitationData.code;
      const res = await api.post<models.VAuth, any>('auth/invitation', value);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        if (!res.data.message) {
          this.disp = NOC.APP.MODE.LOGIN;
          this.changeMode(this.disp);
        } else {
          this.error = res.data.message;
        }
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    pushPath(path: string) {
      // this.$router.push(path, () => {});
      this.nowPath = path;
    },
    async forget(mail: string) {
      const api = new API();
      const res = await api.post<any, any>('auth/forget', { mail });
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.CHANGE;
        // this.changeMode(this.disp);
        this.forgetmodal = true;
      } else {
        this.errorModal('送信できませんでした。');
      }
    },
    async changePass(value: any) {
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/change', value);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        this.disp = NOC.APP.MODE.LOGIN;
        this.changeMode(this.disp);
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    async getDocument() {
      const api = new API();
      const res = await api.get<any>('download/document');
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.LOGIN;
        // this.changeMode(this.disp);
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    async getNewsList() {
      const apiGetNews = async () => {
        const api = new API();
        const res = await api.get<any>('news');
        const newsList = res.data.news.filter((news: modelsNews.INews) => {
          if (!news.checked) {
            return news;
          }
        });
        this.newsList = newsList;
      };
      const apiGetAlert = async () => {
        const api = new API();
        const res = await api.get<modelsAlert.VNewsAlertCount>('alert/count');
        this.alertCount = res.data.count;
      };
      await Promise.all([apiGetNews(), apiGetAlert()]);
    },
    checkNews(clickedNews: any) {
      // for (const news of this.newsList as any) {
      //   news.checked = true;
      // }
      for (const news of this.newsList as any) {
        if (news.news_id === clickedNews.news_id) {
          news.checked = true;
        }
      }
    },
    checkAlert(count: number) {
      this.alertCount = count;
    },
    addGtm() {
      if (process.env.VUE_APP_MODE === 'PROD') {
        const GTA = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-P4GTR75');`;
        const GTABody = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P4GTR75" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        const gtaScript: any = document.createElement('script');
        gtaScript.type = '';
        gtaScript.innerText = GTA;
        gtaScript.id = 'lp_gta';
        document.head.appendChild(gtaScript);
        const gtaBodyScript: any = document.createElement('noscript');
        gtaBodyScript.type = '';
        gtaBodyScript.innerText = GTABody;
        gtaBodyScript.id = 'lp_gta2';
        document.body.appendChild(gtaBodyScript);
      }
    },
    deleteGtm() {
      if (document.getElementById('lp_gta')) {
        (document.getElementById('lp_gta') as HTMLInputElement).remove();
      }
      if (document.getElementById('lp_gta2')) {
        (document.getElementById('lp_gta2') as HTMLInputElement).remove();
      }
    },
    async changeContract() {
      await this.check();
    },
    parentMethod(gaget: any) {
      this.ModalValue = gaget;
    },
    isAccountOnlyContract(contract: string) {
      // ログイン時にアカウント画面に遷移させる契約状態か判定
      switch (contract) {
        case NOC.CONTRACT.QUIT:
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
          return true;
        default:
          return false;
      }
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, {}>);
